import { useQuery } from '@tanstack/react-query';
import ChatService from '../services/chat.service';

const chatService = new ChatService();

/**
 * Custom hook to fetch knowledge folders using React Query.
 *
 * @param organizationId - The ID of the organization.
 * @param folderId - Optional folder ID to get subfolders.
 * @param enabled - Whether the query should be enabled.
 * @returns An object containing the query state and the transformed folder data.
 */
export const useGetKnowledgeFolders = (organizationId: string, folderId?: string, enabled = true) => {
    return useQuery<Array<{ id: string; name: string }>>({
        queryKey: ['folders', organizationId, folderId],
        queryFn: async () => {
            if (!organizationId) {
                throw new Error('Organization ID is required to fetch knowledge documents');
            }

            const params: Record<string, unknown> = {
                page: 1,
                limit: 100,
            };

            if (folderId) {
                params['folder_id'] = folderId;
            }

            const response = await chatService.getKnowledgeDocuments(organizationId, params);
            return (
                response.folders?.map((folder) => ({
                    id: folder.id,
                    name: folder.name,
                })) || []
            );
        },
        enabled: enabled && !!organizationId, // Only run the query if enabled and organizationId is provided
    });
};
